import {
  type FetchResult,
  type MutationFunctionOptions,
  useMutation,
} from '@apollo/react-hooks';
import gql from 'graphql-tag';

export const useConvertGPAV2 = (): ((
  options?: MutationFunctionOptions,
) => Promise<FetchResult>) => {
  const [convertGPAV2] = useMutation(gql`
    mutation ($_id: ID!, $originalGPA: Float!, $originalGPAOutOf: Float!) {
      convertGPAV2(
        input: {
          ruleId: $_id
          originalGPA: $originalGPA
          originalGPAOutOf: $originalGPAOutOf
        }
      ) {
        convertedGPA
      }
    }
  `);
  return convertGPAV2;
};
